<!-- PROFILO COMPLETO - Uniforme al calendario -->
<div class="d-flex mb-4 position-relative">
  <!-- Icona grande centrata -->
  <div class="profile-icon-wrapper text-center">
    <div class="icon-circle bg-primary bg-gradient shadow-lg">
      <i class="fas fa-user-circle fa-2x text-white"></i>
    </div>
  </div>
</div>

<!-- Loading -->
@if (!profileForm) {
  <div class="text-center py-5">
    <div
      class="spinner-border spinner-border-lg text-primary shadow-lg"
      style="width: 4rem; height: 4rem"
    ></div>
    <p class="mt-3 text-muted fw-medium">Caricamento profilo...</p>
  </div>
}

<!-- Form -->
@if (profileForm) {
  <div class="profile-form-container position-relative">
    <div class="form-overlay"></div>

    <form [formGroup]="profileForm" (ngSubmit)="updateProfile()" class="profile-form">
      <!-- Nome -->
      <div class="form-group-wrapper mb-4">
        <label class="form-label fw-bold mb-2">
          <i class="fas fa-user text-primary me-2"></i>
          Nome
        </label>
        <div class="input-wrapper position-relative">
          <input
            type="text"
            class="form-control form-control-lg profile-input"
            formControlName="name"
            placeholder="Inserisci il tuo nome completo"
          />
          <div class="input-icon">
            <i class="fas fa-edit"></i>
          </div>
        </div>
      </div>

      <!-- Email (read-only) -->
      <div class="form-group-wrapper mb-4">
        <label class="form-label fw-bold mb-2">
          <i class="fas fa-envelope text-primary me-2"></i>
          Email
        </label>
        <div class="input-wrapper position-relative">
          <input
            type="email"
            class="form-control form-control-lg profile-input"
            formControlName="email"
            [disabled]="true"
          />
          <div class="input-badge bg-secondary">
            <i class="fas fa-lock"></i>
          </div>
        </div>
        <small class="text-muted mt-1 d-block">
          <i class="fas fa-info-circle me-1"></i>
          L'email non può essere modificata per sicurezza
        </small>
      </div>

      <!-- Pulsante submit -->
      <button
        type="submit"
        class="btn btn-primary btn-lg w-100 profile-submit shadow-xl border-0 rounded-4 position-relative overflow-hidden mt-4"
        [disabled]="loading"
      >
        @if (!loading) {
          <i class="fas fa-save me-2"></i>
          <span>Aggiorna Profilo</span>
        } @else {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          <span>Salvataggio in corso...</span>
        }
        <div class="submit-glow"></div>
      </button>

      <!-- Alert success -->
      @if (success) {
        <div
          class="alert alert-success alert-modern mt-4 border-0 shadow-lg position-relative overflow-hidden"
        >
          <div class="alert-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="alert-content">
            <strong>Perfetto!</strong> Profilo aggiornato con successo.
          </div>
        </div>
      }

      <!-- Alert error -->
      @if (error) {
        <div
          class="alert alert-danger alert-modern mt-4 border-0 shadow-lg position-relative overflow-hidden"
        >
          <div class="alert-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="alert-content">
            <strong>Errore!</strong> Impossibile aggiornare il profilo. Riprova più tardi.
          </div>
        </div>
      }
    </form>
  </div>
}

<style>
  /* Icona profilo */
  .profile-icon-wrapper {
    .icon-circle {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05) rotate(5deg);
        box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4) !important;
      }
    }
  }

  /* Form container */
  .profile-form-container {
    position: relative;
  }

  .profile-form-container .form-overlay {
    position: absolute;
    inset: 0;
    /* background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(102, 126, 234, 0.05)); */
    pointer-events: none;
    z-index: 1;
    border-radius: 24px;
  }

  .profile-form {
    position: relative;
    z-index: 2;
  }

  /* Input uniformi con pulsante */
  .profile-form .profile-input {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(15px);
    border: 1px solid rgba(102, 126, 234, 0.3) !important;
    border-radius: 16px !important;
    padding: 0.9rem 1.5rem 0.9rem 3.5rem !important;
    font-weight: 500;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
  }

  .profile-form .profile-input:focus {
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.25) !important;
    border-color: rgba(102, 126, 234, 0.5) !important;
    transform: translateY(-2px);
  }

  .profile-form .profile-input:hover:not(:disabled) {
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.15);
    border-color: rgba(102, 126, 234, 0.4);
  }

  /* Icone input */
  .profile-form .input-icon {
    position: absolute;
    left: 1.25rem;
    top: 50%;
    transform: translateY(-50%);
    color: #667eea;
    font-size: 1.1rem;
    z-index: 3;
  }

  .profile-form .input-badge {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    font-size: 0.8rem;
    color: white;
  }

  /* Pulsante (stessa altezza input) */
  .profile-submit {
    background: linear-gradient(135deg, #667eea, #764ba2) !important;
    font-weight: 600 !important;
    font-size: 1.05rem !important;
    padding: 0.9rem 2rem !important;
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.3) !important;
    position: relative;
    overflow: hidden;
  }

  .profile-submit:hover:not(:disabled) {
    transform: translateY(-3px) !important;
    box-shadow: 0 25px 60px rgba(102, 126, 234, 0.4) !important;
  }

  .profile-submit .submit-glow {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  .profile-submit:hover .submit-glow {
    left: 100%;
  }

  /* Alert moderni */
  .alert-modern {
    border-radius: 16px !important;
    padding: 1.25rem 1.5rem !important;
    display: flex;
    align-items: center;
    gap: 1rem;
    backdrop-filter: blur(10px);

    .alert-icon {
      font-size: 1.5rem;
      width: 40px;
      text-align: center;
      flex-shrink: 0;
    }

    .alert-content {
      flex-grow: 1;
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    .profile-icon-wrapper .icon-circle {
      width: 70px;
      height: 70px;
    }
  }
</style>
